module.exports = __webpack_public_path__ + "static/l2-service-img1-d5a5a5b1833bb0816c0b9f1923a5d48a.jpg";